export function hasDuplicateKeys(text) {
  const source = String(text);
  const stack = [];
  for (let i = 0; i < source.length; i++) {
    const ch = source[i];
    if (ch === '"') {
      let end = i + 1;
      while (end < source.length && source[end] !== '"') end += source[end] === "\\" ? 2 : 1;
      const top = stack[stack.length - 1];
      if (top && top.expectKey) {
        let key;
        try {
          key = JSON.parse(source.slice(i, end + 1)).toLowerCase();
        } catch {
          return true;
        }
        if (top.keys.has(key)) return true;
        top.keys.add(key);
        top.expectKey = false;
      }
      i = end;
    } else if (ch === "{") {
      stack.push({ keys: new Set(), expectKey: true });
    } else if (ch === "[") {
      stack.push(null);
    } else if (ch === "}" || ch === "]") {
      stack.pop();
    } else if (ch === ",") {
      const top = stack[stack.length - 1];
      if (top) top.expectKey = true;
    }
  }
  return false;
}

export function parseJsonWithoutDuplicateKeys(text) {
  if (hasDuplicateKeys(text)) throw new SyntaxError("JSON has duplicate keys");
  return JSON.parse(text);
}
